import type { SupplierOrderItemPayload } from './api/supplierOrdersApi';
import type { ProductVariant } from '../../types/pz';
import { getProductSelectionLabel } from '../../utils/productSelectorLabel';

export interface SupplierOrderVariantAutofill {
  name: string;
  unit: SupplierOrderItemPayload['unit'];
  width?: number;
  height?: number;
  length?: number;
  thickness?: number;
  productCategoryName?: string | null;
  productCategoryColor?: string | null;
  productCategoryDimensionDisplayProfile?: string | null;
  defaultPurchasePrice?: number;
  defaultPurchaseCurrency?: string;
}

export interface SupplierOrderPurchaseAutofillState {
  unitCost?: number | string | null;
  currency?: string | null;
  defaultPurchasePrice?: number | string | null;
  defaultPurchaseCurrency?: string | null;
}

export const buildSupplierOrderVariantLineName = (variant?: ProductVariant): string => {
  if (!variant) return '';
  return getProductSelectionLabel(variant, '');
};

export const getSupplierOrderUnitForVariant = (
  _variant?: ProductVariant,
  currentUnit?: SupplierOrderItemPayload['unit'],
): SupplierOrderItemPayload['unit'] => currentUnit || 'pcs';

export const buildSupplierOrderVariantAutofill = (
  variant: ProductVariant,
  currentUnit?: SupplierOrderItemPayload['unit'],
): SupplierOrderVariantAutofill => ({
  name: buildSupplierOrderVariantLineName(variant),
  unit: getSupplierOrderUnitForVariant(variant, currentUnit),
  width: variant.product?.width ?? variant.width,
  height: variant.product?.height ?? variant.height,
  length: variant.product?.length ?? variant.length,
  thickness: variant.product?.thickness ?? variant.thickness,
  productCategoryName: variant.product?.productCategoryName ?? null,
  productCategoryColor: variant.product?.productCategoryColor ?? null,
  productCategoryDimensionDisplayProfile: variant.product?.productCategoryDimensionDisplayProfile ?? null,
  defaultPurchasePrice: variant.defaultPurchasePrice,
  defaultPurchaseCurrency: variant.defaultPurchaseCurrency,
});

export const isDefaultPurchaseAutofillApplied = (item?: SupplierOrderPurchaseAutofillState): boolean => {
  if (!item?.defaultPurchaseCurrency || item.defaultPurchasePrice == null) return false;
  const defaultPrice = Number(item.defaultPurchasePrice);
  const unitCost = Number(item.unitCost);
  if (!Number.isFinite(defaultPrice) || !Number.isFinite(unitCost)) return false;
  return unitCost === defaultPrice && (item.currency || 'PLN') === item.defaultPurchaseCurrency;
};
